import React from 'react'
import { editorType } from "../creator"
import { editorSections as cppSections } from "../creator/CCPEditor"
import { editorSections as hazardStepSections } from "../creator/HazardStepsEditor"

export const classes = {
  title:{
    fontFamily: 'Montserrat',
    fontSize: 14,
    textAlign:'justify'
  },
  subtitle:{
    fontFamily: 'Montserrat',
    fontSize: 11,
    textAlign:'justify',
    lineHeight: 1.2
  },
  text:{
    fontFamily: 'Montserrat',
    fontSize: 11,
    textAlign:'justify',
    lineHeight: 1.2
  },
  tableText:{
    fontFamily: 'Montserrat',
    fontSize: 18,
  },
  upperNote : {
    fontFamily: 'Montserrat',
    fontSize: 10,
    textAlign: 'left',
  }
}

export default function({x, ...params}){
  switch(x.doctype){
    case editorType.ccp:
      return (
        <div key={x._id} id={x._id} >
          <style>{`
            table {
              border-collapse: collapse;
              width:100%;
              max-width: 950px;
            }
            
            td, th {
              border: 1px solid #999;
              text-align: left;
            }

            #ccp td:nth-child(1) { background: #999 ; }
            #ccp td:nth-child(1) { width: 10% ; }
            #ccp td:nth-child(2) { width: 90% ; }
          `}</style>
          <h2 style={classes.title}>{x.title}</h2>
          <table id="ccp">
            <tbody>
              <tr>
                <td style={classes.tableText} >{cppSections.hazards}</td>
                <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.hazards}}/></td>
              </tr>
              <tr>
                <td style={classes.tableText} >Critical limits</td>
                <td ><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.cl}}/></td>
              </tr>
              <tr>
                <td style={classes.tableText} >Monitoring</td>
                <td>
                  <table style={{width:'100%'}}>
                    <tr>
                      <td style={classes.tableText} >What</td>
                      <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.monitoring_what}}/></td>
                    </tr>
                    <tr>
                      <td style={classes.tableText} >How</td>
                      <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.monitoring_how}}/></td>
                    </tr>
                    <tr>
                      <td style={classes.tableText} >When</td>
                      <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.monitoring_when}}/></td>
                    </tr>
                    <tr>
                      <td style={classes.tableText} >Who</td>
                      <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.monitoring_who}}/></td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td style={classes.tableText} >Corrective actions</td>
                <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.corrective_actions}}/></td>
              </tr>
              <tr>
                <td style={classes.tableText} >Verification</td>
                <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.verification}}/></td>
              </tr>
              <tr>
                <td style={classes.tableText} >Records</td>
                <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.records}}/></td>
              </tr>
            </tbody>
          </table>
        </div>
      )
    case editorType.doc:
      return (
        <div key={x._id}>
          <h2 style={classes.title}>{x.title}</h2>
          <div style={classes.tableText} dangerouslySetInnerHTML={{__html: x.text}}/>
          <p style={classes.subtitle}>
            Records 
          </p>
          <div style={classes.tableText} dangerouslySetInnerHTML={{__html: x.records}}/>
        </div>
      )
    default:
      return (
        <div key={x._id}>
          <h2 style={classes.title}>{x.title}</h2>
          <p style={classes.subtitle}>
            PURPOSE AND INTRODUCTION
          </p>
          <div style={classes.tableText} dangerouslySetInnerHTML={{__html: x.purposeandintroduction}}/> 
          <p style={classes.subtitle}>
            CRITERIA AND INSTRUCTIONS
          </p>
          <div style={classes.tableText} dangerouslySetInnerHTML={{__html: x.criteriaandinstructions}}/>
          <p style={classes.subtitle}>FREQUENCY</p>
          <p style={classes.tableText}>{x.frequency}</p>
          <p style={classes.tableText}>RESPONSIBILITIES</p>
          <div style={classes.tableText} dangerouslySetInnerHTML={{__html: x.responsibilities}}/>
          <p style={classes.subtitle}>MONITORING</p>
          <div style={classes.tableText} dangerouslySetInnerHTML={{__html: x.monitoring}}/> 
          <p style={classes.subtitle}>CORRECTIVE ACTIONS</p>
          <div style={classes.tableText} dangerouslySetInnerHTML={{__html: x.correctiveactions}}/>
          <p style={classes.subtitle}>VERIFICATION AND RECORD KEEPING</p>
          <div style={classes.tableText} dangerouslySetInnerHTML={{__html: x.verificationandrecordkeeping}}/>
          <p style={classes.subtitle}>RECORDS</p>
          <div style={classes.tableText} dangerouslySetInnerHTML={{__html: x.records}}/>
        </div>
      )
  }
}
